module.exports = __webpack_public_path__ + "static/media/left.005a3577.svg";